export const MESSAGES = {
    TYPE: {
        error: "error",
        success: "success",
    },
    INVALID_CRED: "Invalid credentials",
    SOMETHING_WENT_WRONG: 'Something went wrong',
    AUTHENTICATION: 'Authentication',
    EMAIL_PASSWORD: 'Enter Email/Password',
    PATIENT_CREATED: 'Patient created successfully',
}

export const TOASTR_TIMER = {
    T5_SEC: 5000,
    T6_SEC: 6000,
}